import React, {useEffect, useRef, useState} from "react";
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import ReportOperationBonos from "./report-operation-bonos"
import ReportFCIBackoffice from "./report-fci-backoffice";
import ReportOperationBonosDraft from "./report-operation-bonos-draft";
import ReportOperationInterm from "./report-operation-interm";

function Reports() {

    const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));

    if(userProfile.roleid !== 7){
        return (
            <div className="container-fluid flex-grow-1 container-p-y">
                <Tabs aria-label="tabs" defaultValue={0} sx={{ bgcolor: 'transparent' }} >
                    <TabList
                        disableUnderline
                        sx={{
                        p: 0.5,
                        gap: 0.5,
                        borderRadius: 'xl',
                        // bgcolor: 'background.level1',
                        bgcolor: 'rgba(131, 118, 109, 0.16)',
                        [`& .${tabClasses.root}[aria-selected="true"]`]: {
                            boxShadow: 'sm',
                            bgcolor: 'background.surface',
                            // bgcolor: '#FFFFFF',
                        },
                        }}
                    >
                        <Tab disableIndicator>Mercado</Tab>
                        <Tab disableIndicator>Mercado (Borradores)</Tab>
                        <Tab disableIndicator>FCI</Tab>
                        <Tab disableIndicator>Intermediaciones</Tab>
                    </TabList>
                            
                    <TabPanel value={0}>
                        <ReportOperationBonos />
                    </TabPanel>

                    <TabPanel value={1}>
                        <ReportOperationBonosDraft />
                    </TabPanel>

                    <TabPanel value={2}>
                        <ReportFCIBackoffice />
                    </TabPanel>

                    <TabPanel value={3}>
                        <ReportOperationInterm />
                    </TabPanel>

                </Tabs>
            </div>   
        );
    }

    if(userProfile.roleid === 7){
        return (
            <div className="container-fluid flex-grow-1 container-p-y">
                <Tabs aria-label="tabs" defaultValue={0} sx={{ bgcolor: 'transparent' }} >
                    <TabList
                        disableUnderline
                        sx={{
                        p: 0.5,
                        gap: 0.5,
                        borderRadius: 'xl',
                        // bgcolor: 'background.level1',
                        bgcolor: 'rgba(131, 118, 109, 0.16)',
                        [`& .${tabClasses.root}[aria-selected="true"]`]: {
                            boxShadow: 'sm',
                            bgcolor: 'background.surface',
                            // bgcolor: '#FFFFFF',
                        },
                        }}
                    >
                        <Tab disableIndicator>FCI</Tab>
                    </TabList>
                            
                    <TabPanel value={0}>
                        <ReportFCIBackoffice />
                    </TabPanel>

                </Tabs>
            </div>   
        );
    }

}

export default Reports;